var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ProfilePresenter = /** @class */ (function () {
    function ProfilePresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    ProfilePresenter.prototype.getAbsenteeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getAbsenteeData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.savePreference = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.savePreference.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.saveDashboardFeedback = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveDashboardFeedback.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.downloadAbsenteeFile = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadAbsenteeFile.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getValidateFeedbackData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getValidateFeedbackData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getAbsenteeSampleFile = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getAbsenteeSampleFile.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ProfilePresenter.prototype.getAccountOpeningUrls = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getAccountOpeningUrls.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ProfilePresenter.prototype.getMarkAbsentee = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.markAbsentee.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getDocumentUpload = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.documentUpload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getSupersetMenuList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.supersetMenuList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getUserMenu = function (req) {
        var _this = this;
        this.actions.routeDetails.hideError();
        this.actions.routeDetails.loader("RouteDetails");
        return new Promise(function (resolve, reject) {
            _this.usecase.getUserMenu.execute({
                onSuccess: function (data) {
                    var _a, _b, _c, _d;
                    (_b = (_a = _this.actions) === null || _a === void 0 ? void 0 : _a.routeDetails) === null || _b === void 0 ? void 0 : _b.setUserMenuList(data, "RouteDetails");
                    (_d = (_c = _this.actions) === null || _c === void 0 ? void 0 : _c.routeDetails) === null || _d === void 0 ? void 0 : _d.stopLoader("RouteDetails");
                    resolve(data);
                },
                onError: function (error) {
                    var _a, _b, _c, _d;
                    (_b = (_a = _this.actions) === null || _a === void 0 ? void 0 : _a.routeDetails) === null || _b === void 0 ? void 0 : _b.setError({ isOpen: true, error: error }, "RouteDetails");
                    (_d = (_c = _this.actions) === null || _c === void 0 ? void 0 : _c.routeDetails) === null || _d === void 0 ? void 0 : _d.stopLoader("RouteDetails");
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getPreference = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getPreference.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ProfilePresenter.prototype.getUPCData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getUPCUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getSocialMediaDetails = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.socialMediaDetailsUseCase.execute({
                onSuccess: function (data) {
                    console.log("Data received in presenter", data);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ProfilePresenter.prototype.getClientRatingSummaryDetailsEntity = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.clientRatingSummaryDetailsEntity.execute({
                onSuccess: function (data) {
                    console.log("Data received in presenter", data);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getClientRatingSummaryEntity = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.clientRatingSummaryEntity.execute({
                onSuccess: function (data) {
                    console.log("Data received in presenter", data);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.updateOnDeskDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.updateOnDeskUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    ProfilePresenter.prototype.getONDeskDetails = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.onDeskUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    _this.actions.profileDetails.updateOnDeskDetails(data, "ProfileDetails");
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    ProfilePresenter.prototype.updateClientRatingSummary = function (req) {
        var _this = this;
        this.actions.clientRatingSummaryActions.hideError();
        this.actions.clientRatingSummaryActions.startLoader();
        this.usecase.clientRatingSummary.execute({
            onSuccess: function (data) {
                _this.actions.clientRatingSummaryActions.updateRatingSummary(data);
                _this.actions.clientRatingSummaryActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientRatingSummaryActions.stopLoader();
            },
        }, req);
    };
    ProfilePresenter.prototype.getProfileDetails = function () {
        var _this = this;
        this.actions.profileDetails.hideError("ProfileDetails");
        this.actions.profileDetails.loader("ProfileDetails");
        this.usecase.profileDetailsUseCase.execute({
            onSuccess: function (data) {
                _this.actions.profileDetails.getProfileDetails(data, "ProfileDetails");
                _this.actions.profileDetails.stopLoader("ProfileDetails");
            },
            onError: function (error) {
                _this.actions.profileDetails.setError({ isOpen: true, error: error }, "ProfileDetails");
                _this.actions.profileDetails.stopLoader("ProfileDetails");
            },
        }, null);
    };
    ProfilePresenter.prototype.getRatings = function () {
        var _this = this;
        this.usecase.ratingsUseCase.execute({
            onSuccess: function (data) {
                _this.actions.ratingDetails.getRatings(data, "RatingDetails");
            },
            onError: function (error) {
                console.log("error", error);
            },
        }, null);
    };
    ProfilePresenter.prototype.getProfileImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.profileImageUseCase.execute({
                            onSuccess: function (data) {
                                _this.actions.profileDetails.updateProfileImage(data, "ProfileDetails");
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, null);
                    })];
            });
        });
    };
    ProfilePresenter.prototype.postProfileImage = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var imagepost;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usecase.postProfileImageUseCase.execute({
                            onSuccess: function (data) {
                                imagepost = data;
                            },
                            onError: function (error) {
                                console.log("error", error);
                                imagepost = false;
                            },
                        }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, imagepost];
                }
            });
        });
    };
    ProfilePresenter.prototype.getRMDetailRating = function () {
        var _this = this;
        this.usecase.rmDetailsratingUseCase.execute({
            onSuccess: function (data) {
                _this.actions.rmDetailsRatingActions.getRMDetailRatings(data, "rmDetailsRatingActions");
            },
            onError: function (error) {
                console.log("error", error);
            },
        }, null);
    };
    ProfilePresenter.prototype.getCreaticalActivity = function () {
        var _this = this;
        this.usecase.creaticalActivityUseCase.execute({
            onSuccess: function (data) {
                _this.actions.criticalActivityActions.getCreaticalActivity(data, "criticalActivityActions");
            },
            onError: function (error) {
                console.log("error", error);
            },
        }, null);
    };
    ProfilePresenter.prototype.updateSocailMedia = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var socialmediapost;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usecase.socialMediaUseCase.execute({
                            onSuccess: function (data) {
                                socialmediapost = data;
                            },
                            onError: function (error) {
                                console.log("error", error);
                                socialmediapost = false;
                            },
                        }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, socialmediapost];
                }
            });
        });
    };
    ProfilePresenter.prototype.clearLoginDetails = function () {
        this.actions.profileDetails.resetProfileDetails("ProfileDetails");
    };
    return ProfilePresenter;
}());
export default ProfilePresenter;
